import script from "./GiftStarRow.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftStarRow.vue?vue&type=script&setup=true&lang=js"

import "./GiftStarRow.vue?vue&type=style&index=0&id=c73f8b88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73f8b88"]])

export default __exports__